import { render, staticRenderFns } from "./CalculatedPremium.vue?vue&type=template&id=3b8e61b7&scoped=true&"
import script from "./CalculatedPremium.vue?vue&type=script&lang=js&"
export * from "./CalculatedPremium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8e61b7",
  null
  
)

export default component.exports